import { useEffect, useState } from "react";
import { vpAxios } from "../api";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, X, KeyRound, Copy } from "lucide-react";

export default function EntregadoresPage() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  const load = () => vpAxios.get("/vaipede/entregadores").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const salvar = async (data) => {
    try {
      if (edit) await vpAxios.put(`/vaipede/entregadores/${edit.id}`, data);
      else await vpAxios.post("/vaipede/entregadores", data);
      toast.success("Salvo"); setOpen(false); setEdit(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const excluir = async (id) => {
    if (!window.confirm("Excluir entregador?")) return;
    await vpAxios.delete(`/vaipede/entregadores/${id}`); load();
  };

  const copiarLink = () => {
    const url = `${window.location.origin}/vaipede/entregador/login`;
    navigator.clipboard.writeText(url);
    toast.success("Link do entregador copiado");
  };

  return (
    <div data-testid="vaipede-entregadores">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-black">Entregadores</h1>
          <p className="text-sm text-neutral-500">{rows.length} cadastrados</p>
        </div>
        <div className="flex gap-2">
          <button onClick={copiarLink} className="px-4 py-2.5 rounded-xl bg-white border border-neutral-200 font-bold text-sm flex items-center gap-2" data-testid="vaipede-ent-copiar-link">
            <Copy className="w-4 h-4"/> Link do entregador
          </button>
          <button onClick={() => { setEdit(null); setOpen(true); }} className="px-4 py-2.5 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm flex items-center gap-2" data-testid="vaipede-ent-add">
            <Plus className="w-4 h-4"/> Novo entregador
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-neutral-200 overflow-hidden">
        {rows.length === 0 && (
          <div className="p-10 text-center">
            <KeyRound className="w-8 h-8 text-neutral-300 mx-auto mb-2"/>
            <p className="text-sm text-neutral-500">Cadastre entregadores para eles fazerem login e pegar entregas prontas.</p>
          </div>
        )}
        <div className="divide-y divide-neutral-100">
          {rows.map(e => (
            <div key={e.id} className="p-4 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-red-100 text-[#EA1D2C] grid place-items-center font-bold">🛵</div>
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{e.nome}</div>
                <div className="text-xs text-neutral-500">{e.whatsapp}</div>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full ${e.ativo ? "bg-emerald-100 text-emerald-700" : "bg-neutral-200 text-neutral-500"}`}>
                {e.ativo ? "Ativo" : "Inativo"}
              </span>
              <button onClick={() => { setEdit(e); setOpen(true); }} className="p-2 text-neutral-500 hover:text-neutral-900"><Pencil className="w-4 h-4"/></button>
              <button onClick={() => excluir(e.id)} className="p-2 text-neutral-500 hover:text-red-600"><Trash2 className="w-4 h-4"/></button>
            </div>
          ))}
        </div>
      </div>

      {open && <EntModal initial={edit} onClose={() => { setOpen(false); setEdit(null); }} onSave={salvar}/>}
    </div>
  );
}

function EntModal({ initial, onClose, onSave }) {
  const [f, setF] = useState({
    nome: initial?.nome || "",
    whatsapp: initial?.whatsapp || "",
    senha: "",
    ativo: initial?.ativo !== false,
  });
  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-black text-lg">{initial ? "Editar" : "Novo"} entregador</h2>
          <button onClick={onClose}><X className="w-5 h-5"/></button>
        </div>
        <div className="space-y-2">
          <input value={f.nome} onChange={e => setF({...f, nome: e.target.value})} placeholder="Nome" className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" data-testid="vaipede-ent-nome"/>
          <input value={f.whatsapp} onChange={e => setF({...f, whatsapp: e.target.value})} placeholder="WhatsApp (com DDD)" className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" data-testid="vaipede-ent-whatsapp"/>
          <input type="password" value={f.senha} onChange={e => setF({...f, senha: e.target.value})} placeholder={initial ? "Nova senha (opcional)" : "Senha"} className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" data-testid="vaipede-ent-senha"/>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={f.ativo} onChange={e => setF({...f, ativo: e.target.checked})}/>
            Ativo
          </label>
        </div>
        <button onClick={() => onSave(f)} className="w-full mt-4 py-3 rounded-xl bg-[#EA1D2C] text-white font-bold" data-testid="vaipede-ent-salvar">
          Salvar
        </button>
      </div>
    </div>
  );
}
